var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeightnew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#FCEDFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5882_23980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3429 27.6204L16.5149 30.4494L20.0499 33.9844L33.4849 20.5494L29.9499 17.0144L27.8279 19.1354L29.2429 20.5494L27.8279 21.9634L26.4139 20.5494L24.2929 22.6714L26.4139 24.7914L24.9999 26.2074L22.8789 24.0864L20.7569 26.2074L22.1719 27.6214L20.7569 29.0364L19.3429 27.6214V27.6204ZM30.6569 14.8924L35.6069 19.8424C35.7944 20.0299 35.8997 20.2842 35.8997 20.5494C35.8997 20.8146 35.7944 21.0689 35.6069 21.2564L20.7569 36.1064C20.5694 36.2939 20.315 36.3992 20.0499 36.3992C19.7847 36.3992 19.5304 36.2939 19.3429 36.1064L14.3929 31.1564C14.2054 30.9689 14.1001 30.7146 14.1001 30.4494C14.1001 30.1842 14.2054 29.9299 14.3929 29.7424L29.2429 14.8924C29.4304 14.7049 29.6847 14.5996 29.9499 14.5996C30.215 14.5996 30.4694 14.7049 30.6569 14.8924V14.8924Z",
    fill: "#C174CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5882_23980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeightnew);
export default __webpack_public_path__ + "static/media/heightnew.a71979c08a7584fef8918f6c216c7a83.svg";
export { ForwardRef as ReactComponent };